/**
 * The few line icons the bench's buttons carry. Drawn inline, in the text
 * colour: no icon font to load on the floor's mini-PC. `aria-hidden` because
 * the button's words already name it.
 */

const TRATTI = {
  aggiungi: 'M12 5v14M5 12h14',
  scatola: 'M3 7l9-4 9 4v10l-9 4-9-4V7zM3 7l9 4 9-4M12 11v10',
  stampa: 'M6 9V3h12v6M6 18H4v-7h16v7h-2M8 14h8v7H8z',
  spedisci:
    'M3 6h11v10H3zM14 10h4l3 3v3h-7M7 19a2 2 0 100-4 2 2 0 000 4zM17 19a2 2 0 100-4 2 2 0 000 4z',
  fatto: 'M5 12l5 5L20 7',
  pesa: 'M4 20h16M6 20l2-10h8l2 10M12 10V6M9 6h6',
  cerca: 'M11 18a7 7 0 100-14 7 7 0 000 14zM21 21l-5-5',
  apri: 'M5 12h14M13 6l6 6-6 6',
  vedi: 'M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12zM12 15a3 3 0 100-6 3 3 0 000 6z',
  indietro: 'M19 12H5M11 6l-6 6 6 6',
} as const;

export type NomeIcona = keyof typeof TRATTI;

export function Icona({
  nome,
  sola = false,
}: {
  readonly nome: NomeIcona;
  /** The button has no words: no room kept for them. */
  readonly sola?: boolean;
}) {
  return (
    <svg
      aria-hidden="true"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ verticalAlign: '-0.25em', marginRight: sola ? 0 : 8, flex: '0 0 auto' }}
    >
      <path d={TRATTI[nome]} />
    </svg>
  );
}
